import Loader from "../../../components/common/Loader.js";
import Pagination from "../../../components/common/Pagination.js";
import { getDonorDisplayName } from "../utils.js";

function DonorListSection({
  users,
  loading,
  notFoundMessage,
  role,
  filters,
  handleFilterChange,
  agencies,
  agenciesLoading,
  mentors = [],
  mentorsLoading,
  modes = [],
  modesLoading,
  handleSearchClick,
  handleResetFilters,
  openReceiptModal,
  openUserDetailsModal,
  openOtpModal,
  handleDeleteDonor,
  downloading,
  page,
  totalPages,
  handlePageClick,
}) {
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
            <h4 className="card-title mb-0">All Donors ({users.length})</h4>

            <div className="d-flex flex-wrap align-items-center gap-3">
              <div
                className="position-relative"
                style={{
                  flexGrow: 1,
                  minWidth: "280px",
                  marginTop: "20px",
                }}
              >
                <input
                  className="form-control shadow-sm px-3 py-2 border-2 w-100"
                  type="text"
                  placeholder="Enter name, phone number, or donor id"
                  value={filters.search}
                  aria-label="Search"
                  onChange={(e) => handleFilterChange("search", e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearchClick();
                    }
                  }}
                  style={{ paddingRight: "110px" }}
                />
              </div>

              {/* <div className="d-flex flex-column" style={{ minWidth: "180px" }}>
                <label className="form-label mb-1">Patronship Level</label>
                <Select
                  isMulti
                  placeholder="All Levels"
                  options={[
                    { value: "BRONZE", label: "BRONZE" },
                    { value: "SILVER", label: "SILVER" },
                    { value: "GOLD", label: "GOLD" },
                    { value: "DIAMOND", label: "DIAMOND" },
                  ]}
                  value={
                    filters?.level?.map((val) => ({
                      value: val,
                      label: val,
                    })) || []
                  }
                  onChange={(selectedOptions) => {
                    handleFilterChange(
                      "level",
                      selectedOptions
                        ? selectedOptions.map((opt) => opt.value)
                        : [],
                    );
                  }}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                  }}
                />
              </div> */}

              {/* 
              <div className="d-flex flex-column" style={{ minWidth: "180px" }}>
                <label className="form-label mb-1">Processing Agency</label>
                <select
                  className="form-select"
                  value={filters.agency}
                  onChange={(e) => handleFilterChange("agency", e.target.value)}
                  style={{ width: "100%" }}
                >
                  <option value="">All Agency</option>
                  {!agenciesLoading &&
                    agencies.map((agency) => (
                      <option key={agency.id} value={agency.name}>
                        {agency.name}
                      </option>
                    ))}
                </select>
              </div> */}

              {role !== "mentor" && (
                <div className="d-flex flex-column" style={{ minWidth: "180px" }}>
                  <label className="form-label mb-1">Mentor</label>
                  <select
                    className="form-select"
                    value={filters.mentor}
                    onChange={(e) => handleFilterChange("mentor", e.target.value)}
                    style={{ width: "100%" }}
                  >
                    <option value="">All Mentors</option>
                    {!mentorsLoading &&
                      mentors.map((m) => (
                        <option key={m.id} value={m.mentor_name || m.full_name || m.id}>
                          {m.mentor_name || m.full_name}
                        </option>
                      ))}
                  </select>
                </div>
              )}

              {/* <div className="d-flex flex-column" style={{ minWidth: "180px" }}>
                <label className="form-label mb-1">Status</label>
                <select
                  className="form-select"
                  value={filters.status}
                  onChange={(e) => handleFilterChange("status", e.target.value)}
                  style={{ width: "100%" }}
                >
                  <option value="">All Status</option>
                  <option value="active">Active</option>
                  <option value="closed">Closed</option>
                  <option value="inactive">Inactive</option>
                  <option value="on-hold">On Hold</option>
                </select>
              </div> */}

              <div className="d-flex flex-column" style={{ minWidth: "180px" }}>
                <label className="form-label mb-1">Mode</label>
                <select
                  className="form-select"
                  value={filters.payment_mode}
                  onChange={(e) =>
                    handleFilterChange("payment_mode", e.target.value)
                  }
                  style={{ width: "100%" }}
                >
                  <option value="">All Modes</option>
                  {!modesLoading &&
                    modes.map((m) => (
                      <option key={m.id || m.name} value={m.name}>
                        {m.name}
                      </option>
                    ))}
                </select>
              </div>

              <div>
                <button
                  className="btn btn-primary rounded-pill px-4"
                  onClick={handleSearchClick}
                  style={{ marginTop: "20px" }}
                >
                  Search
                </button>
              </div>

              <div className="d-flex flex-column" style={{ marginTop: "20px" }}>
                <button
                  className="btn btn-icon btn-round btn-dark py-3 px-3 me-2"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Reset Filters"
                  onClick={handleResetFilters}
                >
                  <i className="fas fa-sync-alt"></i>
                </button>
              </div>
            </div>
          </div>

          {downloading && <Loader />}

          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Donor ID</th>
                    <th>Name</th>
                    <th>Mode</th>
                    <th>Phone Number</th>
                    <th>Whatsapp Number</th>
                    <th>Status</th>
                    {role === "admin" && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        <Loader />
                      </td>
                    </tr>
                  ) : notFoundMessage ? (
                    <tr>
                      <td colSpan="7" className="text-center text-danger">
                        {notFoundMessage}
                      </td>
                    </tr>
                  ) : users.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  ) : (
                    users.map((donor) => (
                      <tr key={donor.id}>
                        <td>{donor.donor_id}</td>
                        <td>{getDonorDisplayName(donor)}</td>
                        <td>{donor?.mode}</td>
                        <td>{donor.phone_number || "-"}</td>
                        <td>{donor.whatsapp_number || "-"}</td>
                        <td>{donor?.status}</td>
                        <td>
                          <a
                            href={`https://wa.me/${donor?.phone_number}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-success btn-round btn-icon btn-sm me-2"
                            title="WhatsApp"
                          >
                            <i className="fab fa-whatsapp"></i>
                          </a>

                          <a
                            href={`tel:${donor?.phone_number}`}
                            className="btn btn-dark btn-round btn-icon btn-sm me-2"
                            title="Call"
                          >
                            <i className="fas fa-phone"></i>
                          </a>

                          {/* <button
                            className="btn btn-dark btn-round btn-icon btn-sm me-2"
                            onClick={() => openReceiptModal(donor.id)}
                          >
                            <i className="fas fa-download"></i>
                          </button> */}

                          <button
                            className="btn btn-dark btn-round btn-icon btn-sm me-2"
                            onClick={() => openUserDetailsModal(donor.id)}
                            title="View Details"
                          >
                            <i className="fas fa-eye"></i>
                          </button>

                          {role !== "mentor" && (
                            <button
                              className="btn btn-dark btn-round btn-icon btn-sm me-2"
                              onClick={() => openOtpModal(donor.id)}
                              title="Change Password"
                            >
                              <i className="fas fa-lock"></i>
                            </button>
                          )}

                          {role === "admin" && (
                            <button
                              className="btn btn-danger btn-round btn-icon btn-sm me-2"
                              onClick={() => handleDeleteDonor(donor.id)}
                              title="Delete"
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <Pagination
          page={page}
          totalPages={totalPages}
          handlePageClick={handlePageClick}
        />
      </div>
    </div>
  );
}

export default DonorListSection;
